import React, { PureComponent } from 'react';
import './Header.css';

class Header extends PureComponent {
  render() {
    const { headerClassName } = this.props;

    return (
      <header className={`header row mx-0 align-items-center ${headerClassName}`}>
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-12">
          <div className="row w-100">
            <div className="col-12 col-md-2 col-lg-1 header-image-wrap align-self-center">
              <img
                className="header-image"
                src="/images/nylotto-logo.png"
                alt="New York Lottery logo"
              />
            </div>
            <div className="col-12 col-md-9 col-lg-10 align-self-center pl-2 pl-md-1">
              <img
                className="header-headline"
                src="/images/nylotto-headline.png"
                alt="Can You Imagine?"
              />
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
